module.exports = __webpack_public_path__ + "img/lambda.4be6ca20.svg";